/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContact } from '../models/work-contact';
import { WorkSelfserviceRebateDetailsDto } from '../models/work-selfservice-rebate-details-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceContactsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceContactsV2ControllerGetRevenueRebate()` */
  static readonly SelfserviceContactsV2ControllerGetRevenueRebatePath = '/v2/selfservice/contacts/revenueRebate';

  /**
   * Get revenue rebate information for authenticated contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceContactsV2ControllerGetRevenueRebate()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceContactsV2ControllerGetRevenueRebate$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSelfserviceRebateDetailsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceContactsService.SelfserviceContactsV2ControllerGetRevenueRebatePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSelfserviceRebateDetailsDto>;
      })
    );
  }

  /**
   * Get revenue rebate information for authenticated contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceContactsV2ControllerGetRevenueRebate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceContactsV2ControllerGetRevenueRebate(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkSelfserviceRebateDetailsDto> {
    return this.selfserviceContactsV2ControllerGetRevenueRebate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSelfserviceRebateDetailsDto>): WorkSelfserviceRebateDetailsDto => r.body)
    );
  }

  /** Path part for operation `selfserviceContactsV2ControllerFindOne()` */
  static readonly SelfserviceContactsV2ControllerFindOnePath = '/v2/selfservice/contacts/{id}';

  /**
   * Get contact profile by ID (own profile only).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceContactsV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceContactsV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceContactsService.SelfserviceContactsV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Get contact profile by ID (own profile only).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceContactsV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceContactsV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.selfserviceContactsV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

}
